// ========== Start Open & Close size guide popup ==========
const sizeGuidePopup = document.querySelector('.size-guide');

// ~~~~~~~~~~ Start Helper functions ~~~~~~~~~~
const openSizeGuideModal = (sizeGuidePopup) => {
  sizeGuidePopup.classList.remove('hidden');
  document.body.style.overflow = "hidden";
}

const closeSizeGuideModal = (sizeGuidePopup) => {
  sizeGuidePopup.classList.add('hidden');
  document.body.style.overflow = "auto";
}
// ~~~~~~~~~~ End Helper functions ~~~~~~~~~~

const sizeGuideFunction = function() {
  const sizeGuidebtns = document.querySelectorAll('.size-guide-btn');
  const sizeGuideClose = document.querySelector('.size-guide__close');

  // Open Size Guide 
  sizeGuidebtns.forEach(btn => {
    btn.addEventListener('click', () => openSizeGuideModal(sizeGuidePopup));
  })

  // Close Size Guide
  sizeGuideClose.addEventListener('click', () => closeSizeGuideModal(sizeGuidePopup));
  sizeGuidePopup.addEventListener('click', function(e) {if (e.target === this) closeSizeGuideModal(sizeGuidePopup)});
  window.addEventListener('keydown', e => {if (e.key === 'Escape') closeSizeGuideModal(sizeGuidePopup)});
}

document.addEventListener('DOMContentLoaded', () => {
  if (sizeGuidePopup) sizeGuideFunction()
});
// ========== End Open & Close size guide popup ==========


// ========== Start Type Swatch functionality ==========
const sizeGuideTypes = document.querySelectorAll('.guide__swatch--type');

sizeGuideTypes.forEach(el => {
  el.addEventListener('click', function() {

    if (el.classList.contains('active')) return;

    const getType = this.getAttribute('data-type');
    const sizeGuideSlider = this.closest('.guide-swatch').querySelector('.guide__swatch--slider');
    const sizeGuide = this.closest('.size-guide');
    const allTdSpan = sizeGuide.querySelectorAll('.guide-table td span');
    
    // 1- Remove Active Class
    sizeGuideTypes.forEach(type => type.classList.remove('active'));

    // 2- Add Active Class
    this.classList.add('active');

    // 3- Update Slider
    if (getType == 'in') {
      sizeGuideSlider.classList.remove('active-cm');
      sizeGuideSlider.classList.add('active-in');
    } else if (getType == 'cm') {
      sizeGuideSlider.classList.remove('active-in');
      sizeGuideSlider.classList.add('active-cm');
    } 

    // 4- Update Type
    allTdSpan.forEach(span => span.classList.toggle('hidden'));
  })
})
// ========== End Type Swatch functionality ==========


// ========== Start Mobile options functionality ==========
const mobileSizeOptions = document.querySelectorAll('.mobile-size-options > div');

const showHideMobileSizeColumns = function() {
  if (window.innerWidth < 750) {
    mobileSizeOptions.forEach(option => {
      if (option.classList.contains('active')) {
        const colOrder = option.getAttribute('data-order');
        const thisTableContainer = option.closest('.js-size-table-container');

        thisTableContainer.querySelectorAll('.guide-table tr th:not(:first-child)').forEach(el => el.classList.add('hidden'));
        thisTableContainer.querySelectorAll('.guide-table tr td:not(:first-child)').forEach(el => el.classList.add('hidden'));
    
        thisTableContainer.querySelectorAll(`.guide-table tr th:nth-child(${colOrder})`).forEach(el => el.classList.remove('hidden'));
        thisTableContainer.querySelectorAll(`.guide-table tr td:nth-child(${colOrder})`).forEach(el => el.classList.remove('hidden'));
      }
    })

  } else {
    document.querySelectorAll('.guide-table tr th:not(:first-child)').forEach(el => el.classList.remove('hidden'));
    document.querySelectorAll('.guide-table tr td:not(:first-child)').forEach(el => el.classList.remove('hidden'));
  }
}

document.addEventListener('DOMContentLoaded', showHideMobileSizeColumns);
window.addEventListener('resize', showHideMobileSizeColumns);


mobileSizeOptions.forEach(option => {
  option.addEventListener('click', function() {
    const thisTableContainer = option.closest('.js-size-table-container');
    
    thisTableContainer.querySelectorAll('.mobile-size-options > div').forEach(el => el.classList.remove('active'));
    this.classList.add('active');
    showHideMobileSizeColumns();
  })
})
// ========== End Mobile options functionality ==========

// ========== Start How To Measure Scoll ==========
const howToMeasureBtn = document.querySelector('.measuring-guide-btn');

howToMeasureBtn.addEventListener('click', function(e) {
  const sizeGuidContainer = document.querySelector('.size-guide__container');
  const howToMeasureSection = document.querySelector('.measuring-guide');

  e.preventDefault();

  // sizeGuidContainer.scrollTo({
  //   top: howToMeasureSection.offsetTop,
  //   behavior: 'smooth'
  // });

  howToMeasureSection.scrollIntoView({ behavior: "smooth"});
})
// ========== End How To Measure Scoll ==========